import { CustomFieldEditDate } from "@/components/custom-field/edit/CustomFieldEditDate.tsx";
import { CustomFieldEditCurrency } from "@/components/custom-field/edit/CustomFieldEditCurrency.tsx";
import { CustomFieldEditEmployeeReference } from "@/components/custom-field/edit/CustomFieldEditEmployeeReference.tsx";
import { CustomFieldEditEntityReference } from "@/components/custom-field/edit/CustomFieldEditEntityReference.tsx";
import { CustomFieldEditFile } from "@/components/custom-field/edit/CustomFieldEditFile.tsx";
import { CustomFieldEditSelect } from "@/components/custom-field/edit/CustomFieldEditSelect.tsx";
import { ApiCustomFieldValue, ApiField } from "@/types/custom-field.types.ts";
import { CustomFieldRenderers } from "@skailer-com/uikit";

export const customFieldRenderers: CustomFieldRenderers<ApiField, ApiCustomFieldValue> = {
  select: CustomFieldEditSelect,
  text_array: CustomFieldEditSelect,
  date: CustomFieldEditDate,
  datetime: CustomFieldEditDate,
  currency: CustomFieldEditCurrency,
  file: CustomFieldEditFile,
  image: CustomFieldEditFile,
  employee_reference: CustomFieldEditEmployeeReference,
  entity_reference: CustomFieldEditEntityReference,
};
